import React from "react";

const NewServiceSidebar = ({ selected, onSelect }) => {
  const sections = [
    { id: "basic", label: "Basic details", badge: "Updated" },
    { id: "team", label: "Team members" },
    { id: "resources", label: "Resources" },
    { id: "addons", label: "Service add-ons" },
  ];

  const settings = [
    { id: "online", label: "Online booking" },
    { id: "forms", label: "Forms" },
    { id: "commissions", label: "Commissions" },
    { id: "settings", label: "Settings" },
  ];

  return (
    <aside className="hidden md:block w-64 bg-dry text-text rounded-lg p-0">
      <h3 className="text-sm font-semibold mb-4 text-navy uppercase tracking-wide">
        New service
      </h3>

      {/* Top sections */}
      <ul className="space-y-2 max-h-[40vh] overflow-y-auto scrollbar-thin border border-border rounded-lg mb-6">
        {sections.map((item) => (
          <li
            key={item.id}
            className={`flex items-center justify-between px-3 py-2 rounded-md text-sm cursor-pointer
              ${
                selected === item.id
                  ? "bg-navy text-yellowstar font-medium"
                  : "hover:bg-gray-100 hover:text-navy hover:font-semibold"
              }`}
            onClick={() => onSelect(item.id)}
          >
            <span>{item.label}</span>
            {item.badge && (
              <span className="text-xs bg-navylight text-yellowstar rounded-full px-2 py-0.5">
                {item.badge}
              </span>
            )}
          </li>
        ))}
      </ul>

      {/* Settings */}
      <h3 className="text-sm font-semibold mb-4 text-navy uppercase tracking-wide">
        Settings
      </h3>
      <ul className="space-y-2 max-h-[30vh] overflow-y-auto scrollbar-thin border border-border rounded-lg">
        {settings.map((item) => (
          <li
            key={item.id}
            className={`flex items-center justify-between px-3 py-2 rounded-md text-sm cursor-pointer
              ${
                selected === item.id
                  ? "bg-navy text-yellowstar font-medium"
                  : "hover:bg-gray-100 hover:text-navy hover:font-semibold"
              }`}
            onClick={() => onSelect(item.id)}
          >
            <span>{item.label}</span>
            {item.badge && (
              <span className="text-xs bg-navylight text-yellowstar rounded-full px-2 py-0.5">
                {item.badge}
              </span>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default NewServiceSidebar;
